import React from 'react';
import { MessagePopupCore } from '@utahdts/dts-react-common';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('[GlobalErrorBoundary] Caught error:', error, info);
    MessagePopupCore.addMessage({
      title: 'Unexpected Error',
      message: 'An unexpected error occurred. Please try again or contact support.',
      subMessage: (error && error.message) || 'Unknown error',
    });
  }

  componentDidMount() {
    window.addEventListener('unhandledrejection', this.onUnhandledRejection);
  }

  componentWillUnmount() {
    window.removeEventListener('unhandledrejection', this.onUnhandledRejection);
  }

  onUnhandledRejection = (event) => {
    console.error('[GlobalErrorBoundary] Unhandled promise rejection:', event.reason);
    MessagePopupCore.addMessage({
      title: 'Unhandled Rejection',
      message: 'A background operation failed.',
      subMessage: (event.reason && event.reason.message) || String(event.reason || 'Unknown'),
    });
  };

  render() {
    if (this.state.hasError) {
      return <div>An unexpected error occurred.</div>;
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
